var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"question-element"},[_c('el-tooltip',_vm._b({attrs:{"open-delay":0,"effect":"dark","placement":_vm._placement}},'el-tooltip',_vm.$attrs,false),[_c('i',{staticClass:"el-icon-question"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }